import { render } from "./AddDocument.vue?vue&type=template&id=3bb5bac8&scoped=true"
import script from "./AddDocument.vue?vue&type=script&lang=js"
export * from "./AddDocument.vue?vue&type=script&lang=js"

import "./AddDocument.vue?vue&type=style&index=0&id=3bb5bac8&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb5bac8"]])

export default __exports__